import { render, staticRenderFns } from "./DeptRoleAuthModal.vue?vue&type=template&id=173a6a5c&scoped=true"
import script from "./DeptRoleAuthModal.vue?vue&type=script&lang=js"
export * from "./DeptRoleAuthModal.vue?vue&type=script&lang=js"
import style0 from "./DeptRoleAuthModal.vue?vue&type=style&index=0&id=173a6a5c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173a6a5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('173a6a5c')) {
      api.createRecord('173a6a5c', component.options)
    } else {
      api.reload('173a6a5c', component.options)
    }
    module.hot.accept("./DeptRoleAuthModal.vue?vue&type=template&id=173a6a5c&scoped=true", function () {
      api.rerender('173a6a5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DeptRoleAuthModal.vue"
export default component.exports